module.exports = __webpack_public_path__ + "static/media/4.d7fc1555.jpg";